
function GetSuggestedProducts() {


    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {

        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors .ColorOptionItem.active:first a").attr("data-id"),
            cache: false,
            success: function (dt) {
                dt = dt.replace("_buyuk", "_kucuk");
                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {

                    $(".AutoGetSuggested").html(dt);

                    $(".AutoGetSuggested .ProductList .Prd").addClass("col-sm-6");
                    $(".AutoGetSuggested .ProductList .Prd").addClass("col-xs-12");
                    $(".AutoGetSuggested .ProductList .Prd:gt(3)").addClass("hidden-xs");

                    //$(".AutoGetSuggested").append(dt);
                    //$(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");

                    if (isMobileResolution()) {
                        SlickSlider("productDetailSuggest");
                    }
                }
            }

        });
    }
}

function SetLastVisitedProductsStorage() {
    var LastVisitedPrds = [];
    var lastPrdsKey = "LastVisitedPrds-" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val();

    if (typeof (Storage) !== "undefined") {
        if ($(".ProductHeader:first").length > 0 || $(".AutoGetLastVisited").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now);
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem(lastPrdsKey);
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("#FirstAngle:first").val();//$("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem").val();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = GetLastVisitedData();

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {
                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {
                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg, ProductName: _prdname });

                if (LastVisitedPrds.length > 10) {
                    LastVisitedPrds.shift();
                }

                localStorage.setItem(lastPrdsKey, JSON.stringify(LastVisitedPrds));
            }
        }
    }
}

function SlickSlider(SuggestedSlick) {
    if (SuggestedSlick == "suggested") {
        if ($(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
                infinite: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else {
            $(".UseLazyLoadSuggested").Lazy();
        }
    }
    else if (SuggestedSlick == "main") {
        UseSliderObject = "";

        if ($("#NewPd").hasClass("Combines")) {
            UseSliderObject = $('.ProductDetailImages ul');
        }
        else {
            UseSliderObject = $('.ProductDetailsMainImage ul');
        }

        // Main Slider
        if (!isMobileResolution()) {
            UseSliderObject.on('init', function (event, slick, currentSlide, nextSlide) {
                $(document).on("mouseover", ".ProductDetailsMainImage ul li.slick-active", function () {
                    useImage = $(this).find("img");
                    var Imagesort = useImage.attr("data-sort");

                    //if (!$(".zoomContainer").hasClass(Imagesort)) {
                    //    var ImageUrl = useImage.attr("src").replace("_buyuk", "_enbuyuk");
                    //    useImage.attr("src", ImageUrl);

                    //    useImage.ezPlus({
                    //        cursor: 'crosshair',
                    //        scrollZoom: true,
                    //        zoomType: 'inner'
                    //    });

                    //    setTimeout(function () {
                    //        $(".zoomContainer:last").addClass(Imagesort);
                    //    }, 200);
                    //}
                });
            });
        }

        UseSliderObject.slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });

        UseSliderObject.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $(".zoomContainer").remove();
        });

        if (!isMobileResolution()) {
            $('.SmallProductImages ul').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: UseSliderObject,
                centerMode: false,
                focusOnSelect: true,
                vertical: true,
                infinite: true,
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
                // prevArrow: "",
                //nextArrow: "<div class='slick-prev slick-arrow'></div>",
                arrows: true
            });
        }

    }
    else if (SuggestedSlick == "combine") {
        if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 0) {
            $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").each(function () {
                $(this).find(".PImage").attr("src", $(this).find(".PImage").attr("data-lazy"));
            });
        }
    }

    if (SuggestedSlick == "search") {
        if ($(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else {
            $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .UseLazyLoadSuggested").each(function () {
                var img = $(this).attr("data-lazy");
                if (img != null && img != "" && img != undefined) {
                    $(this).attr("src", img);
                }
            });
        }
    }

    if (SuggestedSlick == "banner") {
        if ($(".contentTopSpace .ListContainer.list .BannerProductList .Product").length > 2) {
            $(".contentTopSpace .ListContainer.list .BannerProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
                infinite: true,
                slidesToShow: 4,
                lazyLoad: 'ondemand',
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            centerMode: false,
                            adaptiveHeight: true,
                            slidesToShow: 1,
                            infinite: true,
                            dots: true,
                            variableWidth: true
                        }
                    }
                ]
            });
        }
        else {
            $(".UseLazyLoadSuggested").Lazy();
        }

        if ($(".contentTopSpace .ListContainer.list5 .BannerProductList .Product").length > 2) {
            $(".contentTopSpace .ListContainer.list5 .BannerProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
                infinite: true,
                slidesToShow: 5,
                lazyLoad: 'ondemand',
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            centerMode: false,
                            adaptiveHeight: true,
                            slidesToShow: 1,
                            infinite: true,
                            dots: true,
                            variableWidth: true
                        }
                    }
                ]
            });
        }
    }
    if (SuggestedSlick == "banner3lu") {
        if ($(".contentTopSpace .Anasayfa3Lu .BannerBox").length > 1) {
            $(".contentTopSpace .Anasayfa3Lu ").slick({
                infinite: true,
                lazyLoad: 'ondemand',
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            centerMode: false,
                            adaptiveHeight: false,
                            slidesToShow: 1,
                            infinite: true,
                            dots: true,
                            variableWidth: true
                        }
                    }
                ]
            });
        }
        else {
            $(".UseLazyLoadSuggested").Lazy();
        }
    }
    if (SuggestedSlick == "productDetailSuggest") {
        if ($(".contentTopSpace  .SuggestedProductsContainer  .SuggestedProducts  .BannerProductList .Product ").length > 3) {
            $(".contentTopSpace .SuggestedProductsContainer  .SuggestedProducts .BannerProductList").slick({
                //slidesToShow: 2,
                //slidesToScroll: 1,
                lazyLoad: 'ondemand',
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
                arrows: false,
                infinite: true,
                lazyLoad: 'ondemand',
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            centerMode: false,
                            adaptiveHeight: false,
                            slidesToShow: 1,
                            infinite: false,
                            dots: true,
                            variableWidth: true
                        }
                    }]
            });
        }
        else {
            $(".UseLazyLoadSuggested").Lazy();
        }
    }

    //if (!isMobileResolution()) {
    //    if (SuggestedSlick == "lastaddedprd") {
    //        if ($(".contentTopSpace .ListContainer .LastAddedProducts .BannerProductList .Product").length > 3) {
    //            $(".contentTopSpace .ListContainer .LastAddedProducts .BannerProductList").slick({
    //                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-arrow-right'></i></div>",
    //                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-arrow-left'></i></div>",
    //                infinite: true,
    //                slidesToShow: 4,
    //                lazyLoad: 'ondemand',
    //                cssEase: 'linear',
    //                responsive: [
    //                    {
    //                        breakpoint: 991,
    //                        settings: {
    //                            centerMode: false,
    //                            adaptiveHeight: true,
    //                            slidesToShow: 1,
    //                            infinite: true,
    //                            dots: true,
    //                            variableWidth: true
    //                        }
    //                    }
    //                ]
    //            });
    //        }
    //        else {
    //            $(".UseLazyLoadSuggested").Lazy();
    //        }
    //    }
    //}
}

$(document).ready(function () {
    IsfollowForProductDetails();
    GetSuggestedProducts();

    SlickSlider("combine");
    SlickSlider("main");
    SlickSlider("productDetailSuggest");
    $(".UseLazyLoadSuggested").Lazy();

    //if ($("body").hasClass("productdetails")) {
    //    var breadcrumb = parseInt($(".ProductBreadCrumb").css("height").split("px")[0]);
    //    var ProductCodeRow = parseInt($(".ProductCodeRow").css("height").split("px")[0]);

    //    if (!isMobileResolution()) {
    //        window.scrollTo(0, breadcrumb + ProductCodeRow + 10);
    //    } else {
    //        window.scrollTo(0, 0);

    //    }
    //}


    if (!isMobileResolution()) {
        // $(".UseLazyLoadDetail").Lazy();
        // Image Zoom
        $().fancybox({
            selector: '.fancybox',
            slideShow: {
                autoStart: false,
                speed: 500
            },
            buttons: [
                "zoom",
                "slideShow",
                // "thumbs",
                "close"
            ],
            loop: false,
            thumbs: {
                autoStart: true
            }
        });

    } else {
        // Image Zoom
        $().fancybox({
            selector: '.fancybox',
            slideShow: {
                autoStart: false,
                speed: 500
            },
            buttons: [
                "zoom",
                "slideShow",
                // "thumbs",
                "close"
            ]
        });
    }


    $(".ProductDetailsMainImage .zoom").live("click", function () {

        $().fancybox({
            selector: '.fancybox',
            slideShow: {
                autoStart: false,
                speed: 500
            },
            buttons: [
                "zoom",
                "slideShow",
                // "thumbs",
                "close"
            ]

        });

    });



    if ($("body").hasClass("productdetails") && $("#CName").val() == "ProductDetails" && $("#AName").val() == "Index") {
        SetLastVisitedProductsStorage();

        var LastVisitedPrds = GetLastVisitedData();

        if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
            GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
                if (dt != "") {
                    $(".SuggestedProductsContainer.LastVisited .AutoGetLastVisited").append(dt);

                    if ($(".productdetails .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts").length > 0) {
                        SlickSlider("suggested");

                        //if (!isMobileResolution()) {
                        //    $(".UseLazyLoadSuggested").Lazy();
                        //}
                    }
                }
            });
        }
    }

    // To Operations
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {
        var Amount = $(".PriceItem:first").html();
        GetProductInstalments(Amount);
    });

    //SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {

        $basketButton = $(this);
        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var Amount = 1;
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();
        var ProductCode = $basketButton.attr("data-productcode");
        var Productname = $basketButton.attr("data-productname");
        var ColorName = $basketButton.attr("data-color");
        var quantity = $(".Quantity").html();
        var ProductAmount = $basketButton.attr('data-amount');
        var ProductOldAmount = parseFloat($basketButton.attr('data-oldAmount'));
        var discount = $basketButton.attr('data-discount');
    

        $basketButton.prop("disabled", true);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            //var NormalText = $basketButton.text();
            //var AddingText = $basketButton.attr("data-adding");
            //$basketButton.text(AddingText);

            var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

            GenerateLocalLoading($("body"), "show");
            //$(".backdrop").addClass("active");

            AddToCard(data, function (dt) {
                //$basketButton.text(NormalText);

                if (dt.Sonuc == true) {
                    GetSepetIcerik(function (dt) {
                        $("#UserAndBasket").html(dt);
                        generateToolTip();
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $(".SepetProducts .BasketContainer .CartTitle .basket-text").html(getAddBasketMessage($(".SepetProducts .BasketContainer .Center .BasketCenterContent .SepetRow").length));
                        toggleMenusOperation("basket");

                    });
         
                    ProductAmount = parseFloat(ProductAmount);

                    if (ProductAmount == ProductOldAmount) {
                        ProductAmount = 0;
                    }

                    if (quantity == undefined) {
                        quantity = 1;
                    }
                    else {
                        //quantity değeri ' x' olarak geliyordu
                        quantity = quantity.replace("x", "");

                        quantity = quantity.replace(" ", "");
                    }

                    var brandName = $basketButton.attr('data-brandname');

                    //datalayer add_to_Cart
                    var category1 = document.getElementById('category1').value;
                    var category2 = document.getElementById('category2').value;
                    var category3 = document.getElementById('category3').value;
                        var amount = ProductAmount;

                        if (amount == 0) {
                            amount = ProductOldAmount;
                        }

                        var value = parseFloat(amount);

                        var storedCatID = localStorage.getItem('lastViewedCatID');
                        storedCatID = parseInt(storedCatID);
                        var itemListName = localStorage.getItem('lastViewedItemListName');
                        //datalayer
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            'event': 'add_to_cart',
                            'ecommerce': {
                                'currency': 'TRY',
                                'value': value, 
                                'items': [{
                                    'item_name': Productname,
                                    'item_id': ProductCode,
                                    'affiliation': category1,
                                    'coupon': '',
                                    'currency': 'TRY',
                                    'discount': parseInt(discount),
                                    'index': 0,
                                    'item_brand': brandName,
                                    'item_category': category1,
                                    'item_category2': category2,
                                    'item_category3': category3,
                                    'item_list_id': parseInt(storedCatID),
                                    'item_list_name': itemListName,
                                    'item_variant': ColorName.split('-')[0],
                                    'location_id': 'İST',
                                    'price': ProductOldAmount,
                                    'quantity': 1,
                                }]
                            }
                        });
                        //datalayer end

                    // Mobilde sadece sepete ürün eklendiğinde animasyon ile kapatılsın.
                    if (isMobileResolution()) {


                        setTimeout(function () {
                            $(".RightBasket .SepetProducts").removeClass("open");
                            $(".RightBasket .polygon").removeClass("open");
                        }, 3000);
                    }

                    $(".AddToBasket.ProductDetails #Basket").html("SEPETE EKLENDİ<i class='sorsfont-check' style='font-size: 1.2rem; position: relative; top: 3px; left:5px;'></i>");

                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, dt.Deger8, getStandartMessages("Kapat"));
                }

                GenerateLocalLoading($("body"), "hide");
                //$(".backdrop").removeClass("active");
                $basketButton.prop("disabled", false);
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {
                $(".backdrop").addClass("active");
                $(".SizeOptions").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");

                $(".ProductOptions").addClass("PleaseSelectFixedArea");

                //setTimeout(function () {
                //    $(".ProductOptions").addClass("PleaseSelectFixedArea");
                //}, 500);

                //if ($(window).width() > 767) {
                //    $(".ProductOptions").css("position", "unset");
                //    $("body").css("overflow", "hidden");
                //}

                var OptionAreaScrollTop = 0;
                if (isMobileResolution()) {
                    OptionAreaScrollTop = $(".SizeOptions").offset().top - 250;
                }

                $('html, body').animate({
                    scrollTop: OptionAreaScrollTop
                }, 500);

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ColorID == undefined || ColorID == "") {
                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);

        }

        e.preventDefault();
        return false;
    });

    //Ürün Beden Seçimi
    $('.SizeOptions a:not(.NotifyWhen)').live("click", function () {
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("span").removeClass("active");
        $(this).addClass("active");
        $(this).parent().addClass("active");

        if ($(".NewPD").length > 0) {
            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");
            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");

            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }

            $(".AddToBasket button").removeClass("NotSelected");

            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {
                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");
            $(".AddToBasket").removeClass("PleaseSelect");
            $(".ProductOptions").removeClass("PleaseSelectFixedArea");
            $(".AddToBasket.ProductDetails #Basket").prop("disabled", false);

            $(".backdrop").removeClass("active");

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }
        }
    });

    // Renk Değişimi
    $("#changeColor").live("click", function (e) {
        var LangID = $("#LangID").val();
        var ProductID = $(this).attr("data-productID");
        var ColorID = $(this).attr("data-id");
        button = $(this);

        ChangeProductColor(ProductID, ColorID, LangID, function (data, status) {
            if (status == true && data != null && data != undefined && data != "") {

                // #region ProductImages
                if (isMobileResolution()) {
                    $(".ProductDetailsMainImage > ul").slick('unslick');
                }

                $(".ProductDetailsMainImage > ul li").remove();

                if (data.ImagePath != null && data.ImagePath != undefined && data.ImagePath != "") {
                    var Images = data.ImagePath.split(';');

                    $.each(Images, function (k, v) {
                        $(".ProductDetailsMainImage > ul").append('<li class="ImgArea fancybox" href="' + v.replace("_enbuyuk", "_buyuk") + '"><img src="' + v.replace("_enbuyuk", "_buyuk") + '"  /></li>');
                    });
                }

                if (isMobileResolution()) SlickSlider("main");
                // #endregion

                // #region ProductSizes
                $(".SizeOptions").html("");

                if ($(".SizeOptions #SelectSizePopup").length > 0) {
                    selectSizePopup = $(".SizeOptions #SelectSizePopup").clone();
                    $(".SizeOptions").append(selectSizePopup);
                }

                $(".SizeOptions").removeClass("passed");
                $("#SizeID").val("");

                if (data.Sizes != null && data.Sizes != undefined && data.Sizes != "") {
                    var size = JSON.parse(data.Sizes);
                    var newSizeCount = 0;

                    $.each(size, function (k, v) {
                        var stil = "";

                        if (v.InStock == "false" || v.PStatus != "1") {
                            stil = "OutOfQuantity";

                            if ($(".NewPD").length > 0) {
                                $(".SizeOptions").append('<span class="outer">' +
                                    ' <input type="hidden" name="SizeIDs" id="SizeIDs" value="' + v.ID + '" >' +
                                    ' <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + v.Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
                                    '<a href="javascript:;" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
                                    ' </span><i class="reactangle"></i></span>'
                                    + '<span class="inner">' + v.Name + '</span></span>');
                            } else {
                                $(".SizeOptions").append('<span class="outer"><span class="inner">' + v.Name + '</span></span>');
                            }
                        }
                        else {
                            $(".SizeOptions").append('<span><a data-id="' + v.ID + '" data-stock="' + v.InStock + '" data-name="' + v.Name + '" href="javascript:void(0)" class="' + stil + " " + v.Name + '">' + v.Name + '</a></span>');

                            newSizeCount++;
                        }
                    });

                    if (newSizeCount > 0) {
                        $(".AddToBasket").html("<button type='button' name='Basket' data-adding='" + getStandartMessages("LutfenBekleyin") + "' id='Basket' class='CartButtonColor NotSelected btn-theme-black'>" + $(".AddToBasketHidden").val() + "</button>");
                    }
                    else {
                        $(".AddToBasket").html("<span class='NotAvailableProduct'>" + $(".TukendiHidden").val() + "</span>");
                    }
                }
                // #endregion

                $(".ProductHeader").html(data.ColorName + " " + data.ProductName);
                $(".ProductDetail .Colors .ColorThumb span").html(data.ColorName);
                document.title = data.ColorName + " " + data.ProductName + " | OriginalSeconds";

                $(".Prices .ProductCode span").html(data.ProductCode);
                $(".PriceContainer .PriceOld").html(data.CurrencySymbol + " " + data.AmountOld.toFixed(2));
                $(".PriceContainer .Price ").html(data.CurrencySymbol + " " + data.Amount.toFixed(2));

                $(".Colors .ColorOption .active").removeClass("active");
                $(".AddToFavorite").attr("data-id", ProductID);
                button.parent().addClass("active");

                $("#PID").val(ProductID);
                $("#ProductID").val(ProductID);
                $("#ColorID").val(ColorID);
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }
        });
    });

    // Favorilere Ekleme
    $(".passiveFavorite").live("click", function () {
        button = $(this);
        $WishButton = $(this);
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var ProductCode = $WishButton.attr("data-productcode");
        var Productname = $WishButton.attr("data-productname");
        var ColorName = $WishButton.attr("data-color");
        var quantity = $(".Quantity").html();
        var ProductAmount = $WishButton.attr('data-amount');
        var ProductOldAmount = parseFloat(button.attr('data-oldAmount'));
        var discount = $WishButton.attr('data-discount');
        

        OverlayElement = $(".ProductDetail");
        if ($(window).width() < 992) {
            OverlayElement = $(".BasktButtons");
        }

        GenerateLocalLoading(OverlayElement, "show");

        if (ColorID != undefined && ProductID != undefined) {
            AddToFavorite(ColorID, ProductID, function (result, msg) {
                if (result == true) {
                    button.addClass("activeFavorite");
                    button.removeClass("passiveFavorite");
                    var xyz = button.find("#Favori");
                    xyz.text("FAVORİLERİMDEN ÇIKAR");

                    button.find(".sorsfont").removeClass("sorsfont-Star").addClass("sorsfont-Star-o");

                    //SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    //setTimeout(function () {
                    //    if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                    //        $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                    //    }
                    //}, 5000);

                    ProductAmount = parseFloat(ProductAmount);

                    if (ProductAmount == ProductOldAmount) {
                        ProductAmount = 0;
                    }

                    if (quantity == undefined) {
                        quantity = 1;
                    }
                    else {
                        //quantity değeri ' x' olarak geliyordu
                        quantity = quantity.replace("x", "");

                        quantity = quantity.replace(" ", "");
                    }

                    var brandName = $WishButton.attr('data-brandname');

                    //datalayer add_to_Cart
                    var category1 = document.getElementById('category1').value;
                    var category2 = document.getElementById('category2').value;
                    var category3 = document.getElementById('category3').value;
                    var amount = ProductAmount;

                    if (amount == 0) {
                        amount = ProductOldAmount;
                    }

                    var value = parseFloat(amount);

                    var storedCatID = localStorage.getItem('lastViewedCatID');
                    storedCatID = parseInt(storedCatID);
                    var itemListName = localStorage.getItem('lastViewedItemListName');

                    //datalayer add_to_wishlist
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event': 'add_to_wishlist',
                        'ecommerce': {
                            'currency': 'TRY',
                            'value': value,
                            'items': [{
                                'item_name': Productname,
                                'item_id': ProductCode,
                                'affiliation': category1,
                                'coupon': '',
                                'currency': 'TRY',
                                'discount': parseInt(discount),
                                'index': 0,
                                'item_brand': 'OS',
                                'item_category': category1,
                                'item_category2': category2,
                                'item_category3': category3,
                                'item_list_id': storedCatID,
                                'item_list_name': itemListName,
                                'item_variant': ColorName.split('-')[0],
                                'location_id': 'İST',
                                'price': ProductOldAmount,
                                'quantity': 1,

                            }]
                        }
                    });
                }
                else {
                    var loginLink = getRequestRoute() + "/p/User/Login";

                    SwalGenerate("warning", msg, "Favorilere Eklenemedi", "<a class='loginbtn'>" + getStandartMessages("GirisYap") + "</a>");
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    function BasketAddMessage() {
        Swal.fire({
            html: "Ürün(ler) sepetinize eklendi.",
            icon: "success",
            showCloseButton: true,
            confirmButtonText: "<a href='/tr/p/CheckOut/sepet?rf=sepet' style='color:#fff;font-weight:600;'>Siparişi Tamamla</a>",
            confirmButtonColor: "#a5dc86",
            showCancelButton: true,
            cancelButtonText: '<span style="color:#595959;font-weight:600">Alışverişe Devam Et</span>',
            cancelButtonColor: "#eaeaea"
        });
    }

    // Favorilerden Çıkarma
    $(".activeFavorite").live("click", function () {
        var ProductID = $("#ProductID").val();
        button = $(this);

        OverlayElement = $(".ProductDetail");
        if ($(window).width() < 992) {
            OverlayElement = $(".BasktButtons");
        }

        GenerateLocalLoading(OverlayElement, "show");

        if (ProductID != undefined) {
            removeFavorite(ProductID, function (result) {
                if (result == true) {
                    button.addClass("passiveFavorite");
                    button.removeClass("activeFavorite");
                    var xyz = button.find("#Favori");
                    xyz.text("FAVORİLERİME EKLE");
                    button.find(".sorsfont").removeClass("sorsfont-Star-o").addClass("sorsfont-Star");

                    // location.reload();

                    //SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    //setTimeout(function () {
                    //    if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                    //        $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                    //    }
                    //}, 5000);
                }
                else {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    // Stoğa Gelince Haber Ver Modal
    $("a.NotifyWhen").live("click", function myfunction() {
        var ProductID = $("#ProductID:first").val();
        var ColorID = $("#ColorID").val();
        var SizeID = $(this).parent().parent().parent().find("input[name=SizeIDs]").val();

        if (ProductID != "" && ProductID != null && ProductID != undefined && typeof ProductID !== 'undefined' && ColorID != null && ColorID != "" && ColorID != undefined && SizeID != null && SizeID != "" && SizeID != undefined) {
            var params = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&SizeID=" + SizeID;
            GetListForRemind(params);
        }
    });

    // Stoğa Gelince Haber Action
    $("#NotifyModal #RemindMeLater.active").live("click", function myfunction() {
        var StockIDs = "?x=";
        var curVal = 0;

        $(".NotiyfyRow .OutOfStockRemind").each(function (index) {
            StockIDs += "&[" + curVal + "].StockID=" + $(this).attr("data-StockID");
            StockIDs += "&[" + curVal + "].SizeID=" + $(this).attr("data-sizeID");
            StockIDs += "&[" + curVal + "].ProductID=" + $(this).attr("data-ProductID");
            StockIDs += "&[" + curVal + "].ProductCode=" + $(this).attr("data-ProductCode");
            StockIDs += "&[" + curVal + "].ColorID=" + $(this).attr("data-colorid");

            curVal++;
        });

        var name = $('input[name="NameModal"]').val();
        var username = $('input[name="UserNameModal"]').val();

        var gsm = $('input[name="GsmModal"]').val();
        var gsmLen = 0;

        if (gsm != "" && gsm != null) {
            gsmLen = gsm.length;
        }

        //var kvkk = $('input[name="KVKKModal"]').prop("checked");
        var kvkk = true;

        if (kvkk == true && name != null && username != null && name != "" && username != "" && gsm != "") {
            if (gsmLen < 10) {
                SwalGenerate("error", getStandartMessages("GecerliTelefonNumarasi"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
            }
            else {
                var param = StockIDs + "&Name=" + name + "&UserName=" + username + "&Gsm=" + gsm + "&kvkk=" + kvkk;
                RemindMeWhenAvailable(param);
            }
        }
        else {
            SwalGenerate("warning", getStandartMessages("LutfenTumAlanlariDoldurun"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
        }

        return false;
    });
    // To Operations

    // Slider Setting
    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {
                $("img", this).addClass("Selected");
            }
            else {
                $("img", this).removeClass("Selected");
            }
        });
    });

    // Open SizeTable Modal
    $(".SizeTableLink").live("click", function () {
        $("#SizeTable").modal();
    });

    // Backdrop Setting
    $("body.productdetails .backdrop").on("click", function (e) {
        $(".backdrop").removeClass("active");

        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".SizeOptions, .CombineSizeOptions").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");

        $(".ProductOptions").removeClass("PleaseSelectFixedArea");
        $(".AddToBasket.ProductDetails #Basket").prop("disabled", false);

        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }

        if (!isMobileResolution()) {
            $("body").css("overflow", "unset");
        }

        $("body").removeClass("no-scroll");
    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {
        $(".SizeOptions .ONE.SIZE").trigger("click");
    }


    if ($(".fancybox-container .fancybox-thumbs .fancybox-thumbs__list a").length > 5) {

        $(".fancybox-container .fancybox-thumbs .fancybox-thumbs__list a:first-child").addClass("hidden");
        $(".fancybox-container .fancybox-thumbs .fancybox-thumbs__list a:last-child").addClass("hidden");
        alert("aaa");
    }

});
